export default class ItemAmountUIModel { 
  constructor({
    currencyCode = '',
    dAmount = 0,
    decimalPlace = 0,
    refundedTo = '',
    sAmount = '',
    type = '',
  }) {
    this.currencyCode = currencyCode;
    this.dAmount = dAmount;
    this.decimalPlace = decimalPlace;
    this.refundedTo = refundedTo;
    this.sAmount = sAmount;
    this.type = type;
  }
}